"use strict";

import {
  GetRowIdParams,
  IServerSideDatasource,
  IServerSideGetRowsRequest,
} from "ag-grid-enterprise";
import { AgGridReact, CustomCellRendererProps } from "ag-grid-react";
import React, { useCallback, useEffect, useMemo } from "react";
import { useRef, useState } from "react";
import {
  ColDef,
  ColGroupDef,
  DefaultMenuItem,
  GetContextMenuItemsParams,
  GridReadyEvent,
  MenuItemDef,
} from "ag-grid-community";
import { randomId, useDebouncedState, useDisclosure } from "@mantine/hooks";
import { MessageResponse } from "../../../../model/MessageResponse";
import {
  paginationPageSize,
  paginationPageSizeSelector,
  repositoryMdm,
} from "../../../../_base/_const/_constVar";
import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
import {
  Badge,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Select,
  TextInput,
  Title,
} from "@mantine/core";
import { getMasterOrgSelect } from "../../../../service/getSelectApi";
import { Text } from "@mantine/core";
import {
  changeSearchValue,
  getValueById,
} from "../../../../_base/helper/FunctionHelper";
import {
  formatDateTime,
  formatDateTransfer,
} from "../../../../common/FormatDate/FormatDate";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import {
  IconBuildingSkyscraper,
  IconCalendar,
  IconDevicesPc,
  IconFileTypeCsv,
  IconSearch,
} from "@tabler/icons-react";
import { BASE_API_MDM } from "../../../../config";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { useLocation } from "react-router-dom";
import { DatePickerInput } from "@mantine/dates";

const SalesReportByInvoiceWithBatchCodes = () => {
  const [loading, setLoading] = useState(true);
  const gridRef = useRef<AgGridReact<any>>(null);
  const [height, setHeight] = useState(825);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const containerStyle = useMemo(() => ({ width: "100%", height: height }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const [search, setSearch] = useState<any>({
    TuNgay:
      _searchJson && checkedPinSearch
        ? _searchJson?.TuNgay
        : new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    DenNgay:
      _searchJson && checkedPinSearch
        ? _searchJson?.DenNgay
        : new Date(new Date().getTime() + 7 * 3600 * 1000).toISOString(),
    MaCn: _searchJson && checkedPinSearch ? _searchJson?.MaCn : "",
    MaDan: _searchJson && checkedPinSearch ? _searchJson?.MaDan : "",
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const dataStatusGeneral = [
    { label: "Kho xuất hàng", value: "KHO_XUAT_HANG" },
    { label: "Thành công", value: "THANH_CONG" },
    { label: "Test OK", value: "TEST_OK" },
    { label: "Đơn hàng hoàn thành", value: "DON_HANG_HOAN_THANH" },
    { label: "Đơn hàng tạm", value: "DON_HANG_TAM" },
    { label: "Thất bại do KH", value: "THAT_BAI_DO_KH" },
    { label: "KTKT đang kiểm tra", value: "KTKT_DANG_KIEM_TRA" },
    { label: "Đơn hàng chờ duyệt giảm", value: "DON_HANG_CHO_DUYET_GIAM" },
    { label: "Đơn chờ duyệt đổi trả", value: "DON_CHO_DUYET_DOI_TRA" },
    { label: "Đơn đã duyệt đổi trả", value: "DON_DA_DUYET_DOI_TRA" },
    { label: "GV thành công", value: "GV_THANH_CONG" },
    { label: "Nhập lại", value: "NHAP_LAI" },
    { label: "Đã phân công GV", value: "DA_PHAN_CONG_GV" },
    { label: "GV đến nơi", value: "GV_DEN_NOI" },
    { label: "GV đang giao", value: "GV_DANG_GIAO" },
    { label: "Test lỗi", value: "TEST_LOI" },
    { label: "Đã phân công KTKT", value: "DA_PHAN_CONG_KTKT" },
    { label: "Hủy phân công GV", value: "HUY_PHAN_CONG_GV" },
    { label: "Thất bại do HACOM", value: "THAT_BAI_DO_HACOM" },
    { label: "Nhập lại một phần", value: "NHAP_LAI_MOT_PHAN" },
    { label: "Đơn hàng chốt", value: "DON_HANG_CHOT" },
    { label: "Đơn hàng đã duyệt giảm", value: "DON_HANG_DA_DUYET_GIAM" },
    { label: "GV tiếp nhận", value: "GV_TIEP_NHAN" },
    { label: "GV nhập lại", value: "GV_NHAP_LAI" },
    { label: "GV nhập lại một phần", value: "GV_NHAP_LAI_MOT_PHAN" },
    { label: "GV thất bại do HACOM", value: "GV_THAT_BAI_DO_HACOM" },
    { label: "GV thất bại do KH", value: "GV_THAT_BAI_DO_KH" },
    { label: "GV nối chuyến", value: "GV_NOI_CHUYEN" },
    { label: "Hủy phân công KTKT", value: "HUY_PHAN_CONG_KTKT" },
    { label: "KH đã nhận", value: "DA_NHAN" },
  ];
  const warehouseStatus = [
    { value: "DA_YEU_CAU", label: "Đã yêu cầu" },
    { value: "DANG_XUAT", label: "Đang xuất" },
    { value: "DA_XUAT", label: "Đã xuất" },
    { value: "DANG_NHAP", label: "Đang nhập" },
    { value: "DA_NHAP", label: "Đã nhập" },
  ];
  const [dataBranch, setDataBranch] = useState<ComboboxItem[]>([]);

  const getDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: String(item.att1),
        }));
      setDataBranch(data);
    }
  };

  const fetchData = async (request: IServerSideGetRowsRequest) => {
    try {
      let url = `/api/v1/BaoCaoDsTheoHd/get-list?Skip=${
        request.startRow
      }&Take=${Number(request.endRow) - Number(request.startRow)}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      return await repositoryMdm.get<MessageResponse<any[]>>(url);
    } catch (error) {
      console.error(error);
    }
  };

  const exportDataExcel = async () => {
    open();
    try {
      let url = "";

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const baseUrl = `/api/v1/BaoCaoDsTheoHd/export${url.replace(/^&/, "?")}`;

      const _url = BASE_API_MDM + baseUrl;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "bao-cao-ban-hang-theo-hoa-don-co-ma-dan.xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        NotificationExtension.Success("Export Excel thành công !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const getServerSideDataSource: () => IServerSideDatasource = () => {
    return {
      getRows: async (params) => {
        var response = await fetchData(params.request);
        // adding delay to simulate real server call

        if (response && response.success) {
          params.success({
            rowData: response.data.map((i, index) => ({
              ...i,
              id: Number(params.request.startRow) + index + 1,
            })),
            rowCount: response.totalCount,
          });
          console.log(response.data);
          setLoading(false);
        } else {
          // inform the grid request failed
          params.fail();
          setLoading(false);
        }
      },
    };
  };

  const getRowId = useCallback((params: GetRowIdParams) => {
    if (params.data.id != null) {
      return "leaf-" + randomId();
    }
    const rowGroupCols = params.api.getRowGroupColumns();
    const rowGroupColIds = rowGroupCols.map((col) => col.getId()).join("-");
    const thisGroupCol = rowGroupCols[params.level];
    return (
      "group-" +
      rowGroupColIds +
      "-" +
      (params.parentKeys || []).join("-") +
      params.data[thisGroupCol.getColDef().field!]
    );
  }, []);

  const filterParamsDefault = {
    buttons: ["clear", "reset", "apply"],
    debounceMs: 1000,
    maxNumConditions: 5,
  };

  const columnDefs = useMemo<(ColDef | ColGroupDef)[]>(
    () => [
      {
        field: "sO_HD",
        headerName: "Mã đơn hàng",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Badge color="green" variant="dot">
              {params.value}
            </Badge>
          );
        },
      },
      { field: "mA_DAN", headerName: "Mã dàn" },
      { field: "sL_DAN", headerName: "Số lượng dàn" },
      {
        field: "mA_CN",
        headerName: "Chi nhánh",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {getValueById(String(params.value), dataBranch, "label") ||
                params.value}
            </Text>
          );
        },
      },
      {
        field: "mA_BP",
        headerName: "Bộ phận",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {[params.value, params.data.teN_BP]
                .filter((i) => i && String(i).length > 0)
                .join(" - ")}
            </Text>
          );
        },
        width: 375,
      },
      {
        field: "mA_KH",
        headerName: "Khách hàng",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {[params.value, params.data.teN_KH]
                .filter((i) => i && String(i).length > 0)
                .join(" - ")}
            </Text>
          );
        },
        width: 300,
      },
      { field: "mA_DTCN", headerName: "Đối tượng công nợ" },
      { field: "teN_CONG_TY", headerName: "Công ty", width: 375 },
      { field: "mst", headerName: "Mã số thuế" },
      { field: "sO_DT", headerName: "Số điện thoại" },
      { field: "phuonG_THUC_THANH_TOAN", headerName: "Phương thức thanh toán" },
      { field: "mA_VOUCHER", headerName: "Mã voucher" },
      {
        field: "ordeR_DATE",
        headerName: "Ngày đặt hàng",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value && formatDateTransfer(params.value)}
            </Text>
          );
        },
      },
      {
        field: "ngaY_NHAP_XUAT",
        headerName: "Ngày nhập xuất",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value && formatDateTransfer(params.value)}
            </Text>
          );
        },
      },
      {
        field: "ngaY_TAO",
        headerName: "Ngày tạo",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>{params.value && formatDateTime(params.value)}</Text>
          );
        },
      },
      {
        field: "ngaY_HACH_TOAN",
        headerName: "Ngày hạch toán",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>{params.value && formatDateTime(params.value)}</Text>
          );
        },
      },
      {
        field: "tranG_THAI_CHUNG",
        headerName: "Trạng thái chung",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {getValueById(String(params.value), dataStatusGeneral, "label")}
            </Text>
          );
        },
      },
      {
        field: "tranG_THAI_XUAT_KHO",
        headerName: "Trạng thái xuất kho",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {getValueById(String(params.value), warehouseStatus, "label")}
            </Text>
          );
        },
      },
      { field: "nguoI_TAO", headerName: "Người tạo" },
      { field: "nguoI_HUONG_SO", headerName: "Người hưởng số" },
      {
        field: "tieN_DON_HANG",
        headerName: "Tiền đơn hàng",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "tieN_CK",
        headerName: "Tiền chiết khấu",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "tieN_GG",
        headerName: "Tiền giảm giá",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "tieN_CK_GG",
        headerName: "Tổng CK & GG",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "tieN_SAU_CK_GG",
        headerName: "Tiền sau CK & GG",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "tieN_VON",
        headerName: "Tiền vốn",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "tieN_LAI",
        headerName: "Tiền lãi",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "tieN_DA_TRA",
        headerName: "Tiền đã trả",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "coN_NO",
        headerName: "Còn nợ",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "amounT_TOTAL",
        headerName: "Tổng cộng",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "amounT_PAID",
        headerName: "Số tiền đã thanh toán",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "amounT_REMAINING",
        headerName: "Số tiền còn lại",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || String(params.value) === "0"
                ? Number(params.value).toLocaleString()
                : ""}
            </Text>
          );
        },
      },
      {
        field: "mA_NHOM",
        headerName: "Nhóm hàng",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {[params.value, params.data.teN_NHOM]
                .filter((i) => i && String(i).length > 0)
                .join(" - ")}
            </Text>
          );
        },
      },
      // { field: "teN_NHOM", headerName: "Tên nhóm" },
      { field: "kenH_BAN", headerName: "Kênh bán" },
    ],
    [dataBranch, dataStatusGeneral, warehouseStatus],
  );

  const defaultColDef = useMemo<ColDef>(() => {
    return {
      autoHeaderHeight: true,
      allowedAggFuncs: ["sum", "min", "max", "avg"],
      filter: false,
      enableRowGroup: true,
      enableValue: true,
      floatingFilter: false,
      floatingFilterComponentParams: {
        showDisabledCheckboxes: true,
      },
      filterParams: filterParamsDefault,
    };
  }, []);

  const defaultColGroupDef = useMemo<Partial<ColGroupDef>>(() => {
    return {
      headerName: "A shared prop for all Groups",
    };
  }, []);

  const onGridReady = useCallback(async (params: GridReadyEvent) => {
    var datasource = getServerSideDataSource();
    // register the datasource with the grid
    params.api!.setGridOption("serverSideDatasource", datasource);
  }, []);

  const handleSearch = useCallback(() => {
    if (gridRef.current && gridRef.current.api) {
      setLoading(true);
      // Lấy datasource mới chứa state search hiện tại
      const datasource = getServerSideDataSource();
      // Set lại datasource để Grid query lại từ đầu (trang 1) với params mới
      gridRef.current.api.setGridOption("serverSideDatasource", datasource);
    }
  }, [search, keySearch]); // Dependency quan trọng để lấy state mới

  const statusBar = useMemo(
    () => ({
      statusPanels: [
        { statusPanel: "agTotalAndFilteredRowCountComponent" },
        { statusPanel: "agTotalRowCountComponent" },
        { statusPanel: "agFilteredRowCountComponent" },
        { statusPanel: "agSelectedRowCountComponent" },
        { statusPanel: "agAggregationComponent" },
      ],
    }),
    [],
  );

  const getContextMenuItems = useCallback(
    (params: GetContextMenuItemsParams): (DefaultMenuItem | MenuItemDef)[] => {
      var result: (DefaultMenuItem | MenuItemDef)[] = [
        "cut",
        "copy",
        "copyWithHeaders",
        "copyWithGroupHeaders",
        "paste",
        "separator",
        "chartRange",
        "export",
      ];
      return result;
    },
    [window],
  );

  useEffect(() => {
    Promise.all([getDataBranch()]);
  }, []);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (290 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <div style={containerStyle}>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={15}> Đang xử lý....</Title>
            </Flex>
          ),
        }}
      />
      <Flex justify={"space-between"} align={"center"} w={"100%"}>
        <_breadcrumb></_breadcrumb>
        <Flex gap={"md"}>
          <Button
            leftSection={<IconFileTypeCsv size={16} />}
            onClick={() => exportDataExcel()}
          >
            Export Excel
          </Button>
        </Flex>
      </Flex>
      <Grid mb={10}>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <TextInput
            placeholder="Nhập từ khóa tìm kiếm"
            defaultValue={keySearch}
            onChange={(e) => setKeySearch(e.currentTarget.value)}
            leftSection={<IconSearch color="#15aabf" />}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <DatePickerInput
            size="sm"
            placeholder="Chọn ngày bắt đầu"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            value={
              search.TuNgay && search.TuNgay?.length > 0
                ? new Date(search.TuNgay ?? "")
                : null
            }
            maxDate={
              search.DenNgay && search.DenNgay?.length > 0
                ? new Date(search.DenNgay)
                : new Date()
            }
            onChange={(e) => {
              changeSearchValue(
                e
                  ? new Date(
                      new Date(e).getTime() + 7 * 3600 * 1000,
                    )?.toISOString()
                  : "",
                "TuNgay",
                setSearch,
              );
            }}
            leftSection={<IconCalendar color="#15aabf" />}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <DatePickerInput
            size="sm"
            placeholder="Chọn ngày kết thúc"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            value={
              search.DenNgay && search.DenNgay?.length > 0
                ? new Date(search.DenNgay ?? "")
                : null
            }
            minDate={
              search.TuNgay && search.TuNgay?.length > 0
                ? new Date(search.TuNgay)
                : undefined
            }
            onChange={(e) => {
              changeSearchValue(
                e
                  ? new Date(
                      new Date(e).getTime() + 7 * 3600 * 1000,
                    )?.toISOString()
                  : "",
                "DenNgay",
                setSearch,
              );
            }}
            leftSection={<IconCalendar color="#15aabf" />}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <Select
            placeholder="Chi nhánh"
            leftSection={<IconBuildingSkyscraper color="#15aabf" />}
            data={dataBranch}
            value={search.MaCn ? search.MaCn : ""}
            searchable
            clearable
            onChange={(e) => changeSearchValue(e ? e : "", "MaCn", setSearch)}
            nothingFoundMessage="Không tìm thấy dữ liệu !"
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <Select
            placeholder="Mã dàn máy"
            leftSection={<IconDevicesPc color="#15aabf" />}
            data={[
              { value: "DAND005", label: "DAND005" },
              { value: "DAND004", label: "DAND004" },
              { value: "PCHC005", label: "PCHC005" },
              { value: "PCHC007", label: "PCHC007" },
              { value: "PCHC008", label: "PCHC008" },
              { value: "PCHC009", label: "PCHC009" },
            ]}
            value={search.MaDan ? search.MaDan : ""}
            searchable
            clearable
            onChange={(e) => changeSearchValue(e ? e : "", "MaDan", setSearch)}
            nothingFoundMessage="Không tìm thấy dữ liệu !"
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <Button
            leftSection={<IconSearch size={14} />}
            onClick={() => handleSearch()}
          >
            Tìm kiếm
          </Button>
        </Grid.Col>
      </Grid>
      <div style={gridStyle} className={"ag-theme-quartz"}>
        <AgGridReact<any>
          ref={gridRef}
          loading={loading}
          suppressNoRowsOverlay
          columnDefs={columnDefs}
          defaultColGroupDef={defaultColGroupDef}
          defaultColDef={defaultColDef}
          rowModelType={"serverSide"}
          pagination={true}
          paginationPageSize={paginationPageSize}
          paginationPageSizeSelector={paginationPageSizeSelector}
          cacheBlockSize={paginationPageSize}
          maxBlocksInCache={10}
          onGridReady={onGridReady}
          localeText={AG_GRID_LOCALE_VN}
          sideBar={true}
          enableAdvancedFilter={false}
          masterDetail={true}
          // detailCellRendererParams={detailCellRendererParams}
          rowSelection={"multiple"}
          suppressAggFuncInHeader={true}
          getRowId={getRowId}
          suppressRowClickSelection={true}
          groupSelectsChildren={true}
          blockLoadDebounceMillis={200}
          suppressServerSideFullWidthLoadingRow={false}
          maxConcurrentDatasourceRequests={1}
          animateRows={true}
          rowBuffer={paginationPageSize}
          purgeClosedRowNodes={true}
          pivotPanelShow={"always"}
          rowGroupPanelShow={"always"}
          statusBar={statusBar}
          enableRangeSelection
          enableCharts
          allowContextMenuWithControlKey={true}
          getContextMenuItems={getContextMenuItems}
          suppressColumnVirtualisation
          paginateChildRows={true}
          paginationAutoPageSize={true}
        />
      </div>
    </div>
  );
};

export default SalesReportByInvoiceWithBatchCodes;
